<template>
    <TemplateTable
      :title="$t('menu.recom_orders')"
      :text="$t('recom_orders.description')"
      name="orders"
      :url="$listRoutes.recomOrders"
      :table="orders"
      :filters="ordersFilters"
      :defaultFilters="defaultPaidAtFilter"
      :fields="fields"
      :requireFilters="true"
      :useCurrency="true"
      scope="filters.tradeInArticles"
      :filtersWording="filtersWording"
    />
  </template>
  
  <script>
  import { mapState } from "vuex";
  import TemplateTable from "@/components/templates/TemplateTable";
  
  export default {
    name: "RecomOrdersPage",
    components: { TemplateTable },
    data() {
        return {
            fields: [
                {key: 'id', type: 'eye', route: 'recom_order', size: 'xs'},
                {key: 'reference', translationKey: 'id', size: 'm'},
                {key: 'brand.name', type: 'client', size: 'l', translationKey: 'client'},
                {key: 'paidAt', translationKey: 'orderDate', type: 'date'},
                {key: 'customer.id', type: 'CmsCustomer', size: 'xl', translationKey: "email"},
                {key: 'customer.profile', type: 'tagType', size: 'm'},
                {key: 'channel', type: 'tagType', translationKey: 'canal'},
                {key: 'total', type: 'formatPrice', translationKey: 'totalttc'},
                {key: 'paymentState', type: 'tagTypePayments', size: 'l', translationKey: 'orderRecom.paymentState', translation: 'orderRecom.paymentState.filterTitle'},
                {key: 'state', type: 'tagType', size: 'l', translationKey: 'orderRecom.state', translation: 'orderRecom.state.filterTitle'},
                {key: 'shipment.state', type: 'tagType', size: 'l', translationKey: 'orderRecom.shipmentState', translation: 'orderRecom.shipmentState.filterTitle'},
                {key: 'shippingDate', type: 'date', size: 's'},
                {key: 'orderReturns', type: 'tagType', size: 'l', translationKey: 'orderRecom.shipmentReturnState', translation: 'orderRecom.shipmentReturnState.filterTitle'},
                {key: 'returnDate', type: 'date', size: 's'},
                {key: 'itemsNb', translationKey: 'countArticles'},
                {key: 'shippingAddress.countryCode', translation: 'global.saleCountry'}
            ],
            filtersWording: {
                paidAt: {
                    filterTitle: this.$t('global.orderDate'),
                },
                state: {
                    filterTitle: this.$t('orderRecom.state.filterTitle'),
                    "validated": this.$t('orderRecom.state.validated'),
                    "canceled": this.$t('orderRecom.state.canceled'),
                    "partially_canceled": this.$t('orderRecom.state.partially_canceled'),
                    "paid": this.$t('orderRecom.state.paid'),
                    "treated": this.$t('orderRecom.state.treated'),
                    "refunded": this.$t('orderRecom.state.refunded'),
                    "partially_refunded": this.$t('orderRecom.state.partially_refunded'),
                },
                shipmentReturnState: {
                    filterTitle: this.$t('orderRecom.shipmentReturnState.filterTitle'),
                    draft: this.$t('orderRecom.shipmentReturnState.draft'),
                    in_transit: this.$t('orderRecom.shipmentReturnState.in_transit'),
                    out_for_delivery: this.$t('orderRecom.shipmentReturnState.out_for_delivery'),
                    delivered: this.$t('orderRecom.shipmentReturnState.delivered'),
                    lost: this.$t('orderRecom.shipmentReturnState.lost'),
                    canceled: this.$t('orderRecom.shipmentReturnState.canceled'),
                },
                paymentState: {
                    filterTitle: this.$t('orderRecom.paymentState.filterTitle'),
                    SUCCESS: this.$t('orderRecom.paymentState.SUCCESS'),
                    FAILURE: this.$t('orderRecom.paymentState.FAILURE'),
                    ERROR: this.$t('orderRecom.paymentState.ERROR'),
                    DISPUTE: this.$t('orderRecom.paymentState.DISPUTE'),
                },
                shipmentState: {
                    filterTitle: this.$t('orderRecom.shipmentState.filterTitle'),
                    draft: this.$t('orderRecom.shipmentState.draft'),
                    in_transit: this.$t('orderRecom.shipmentState.in_transit'),
                    out_for_delivery: this.$t('orderRecom.shipmentState.out_for_delivery'),
                    delivered: this.$t('orderRecom.shipmentState.delivered'),
                    lost: this.$t('orderRecom.shipmentState.lost'),
                    canceled: this.$t('orderRecom.shipmentState.canceled'),
                }
            }
        }
    },
    computed: {
      ...mapState(["orders", "ordersFilters"]),
      defaultPaidAtFilter() {
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return `paidAt[gte]=${date.toISOString().split('T')[0]}`;
      },
    }
  };
  </script>
